import { render, staticRenderFns } from "./OldMyPage.vue?vue&type=template&id=263d1db6&scoped=true&"
import script from "./OldMyPage.vue?vue&type=script&lang=js&"
export * from "./OldMyPage.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/formats.scss?vue&type=style&index=0&lang=scss&"
import style1 from "@/assets/scss/pages/pages.scss?vue&type=style&index=1&lang=scss&"
import style2 from "./OldMyPage.vue?vue&type=style&index=2&id=263d1db6&scoped=true&lang=css&"
import style3 from "./OldMyPage.vue?vue&type=style&index=3&id=263d1db6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263d1db6",
  null
  
)

export default component.exports